<template>
    <v-row justify="center" align-content="center" align="center">
        <v-col order="1" order-md="2" order-lg="2" order-xl="2" class="text-center col-xs-12">
            <v-row v-if="(this.babyData.sexo == 'M')" justify="center" align-content="center" align="center">
                <v-col cols="12">
                    <span class="font-crono-span-revela">SEJA BEM VINDO</span><br>
                    <span class="font-crono-span2">{{this.babyData.FirstNameMenino}}</span><br>
                    <span class='font-crono'> {{this.babyData.votosMenino}} </span>              
                </v-col>                    
            </v-row>
            <v-row v-if="(this.babyData.sexo == 'F')" justify="center" align-content="center" align="center">
                <v-col cols="12">
                    <span class="font-crono-span-revela">SEJA BEM VINDA</span><br>
                    <span class="font-crono-span2">{{this.babyData.FirstNameMenina}}</span><br>
                    <span class='font-crono'> {{this.babyData.votosMenina}} </span>              
                </v-col>                          
            </v-row>
            <v-row justify="center" align-content="center">
                <span class='title font-white'>                     
                    Acertaram
                </span>      
            </v-row> 
            <v-row justify="center" align-content="center">
                <v-col cols="12">
                    <v-row justify="center" align-content="center">
                        <presentear v-if="((typeof this.babyData.endereco != 'undefined') && (typeof this.babyData.listaPresentes != 'undefined'))" :endereco="this.babyData.endereco" :presentes="this.babyData.listaPresentes"/>                 
                    </v-row>                            
                </v-col>
            </v-row>
        </v-col>                      
    </v-row>
</template>
<script src='https://meet.jit.si/external_api.js'></script>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script>
import * as firebase from "firebase"
import presentear from "@/components/presentearComponent"
import preRevelation from "./preRevelation"

export default {
    components:{presentear, preRevelation},
    props: ['babyData'],
    data: () => ({
    }),
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Share+Tech+Mono');

#teste-template {
  height: 100% !important;
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;
}
#teste-template-f {
  height: 100% !important;
  background: #f59cd3;
  /* background-size: cover; */
}
#teste-template-m {
  height: 100% !important;
  background: #51c7fd;
  /* background-size: cover; */
}

#jitsi-container {
    height:100px
}
.font-crono {
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 5em;
    line-height: 1;
} 

@media (max-width: 380px) {
    .font-crono {
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em;
        line-height: 1;
    }; 
    .font-crono-span{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em!important;
        color: rgb(196, 29, 29)!important
    }
    .font-crono-span2{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 2.3em!important;
        color: white!important    
    }        
}

.font-crono-span{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 0.27em!important;
    color: white!important
}
.font-crono-span2{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 4.3em!important;
    color: white!important    
}

.font-crono-span-revela{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 2.3em!important;
    color: white!important    
}
.transparent {
   background-color: white!important;
   opacity: 0;
   border-color: transparent!important;
}
.font-white{
       color: white!important;
}

 .share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF !important;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>